// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rewardContainer {
    display: flex;
    justify-content: space-between;
    min-height: 3rem;
    gap: 1rem;
    margin: 10px 0;
}

.rewardItem {
    display: flex;
    justify-content: center;
    border-radius: 10px;
    background-color: white;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    font-weight: bold;
    align-items: center;
    width: 100%;
}

.dark .rewardItem {
    background-color: #353a50;
    color: white;
}

.disabled-opacity {
    opacity: 0.3;
    background-color: rgba(245, 245, 245, 0.631);
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/tabModal/tabmodal1/tabmodal1.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,yFAAyF;IACzF,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,4CAA4C;AAChD","sourcesContent":[".rewardContainer {\n    display: flex;\n    justify-content: space-between;\n    min-height: 3rem;\n    gap: 1rem;\n    margin: 10px 0;\n}\n\n.rewardItem {\n    display: flex;\n    justify-content: center;\n    border-radius: 10px;\n    background-color: white;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;\n    font-weight: bold;\n    align-items: center;\n    width: 100%;\n}\n\n.dark .rewardItem {\n    background-color: #353a50;\n    color: white;\n}\n\n.disabled-opacity {\n    opacity: 0.3;\n    background-color: rgba(245, 245, 245, 0.631);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
